import { DolfinSupabaseDbRpc } from './supabase'
import { SimulatorDBRpc, SimulatorDBRpcConfig } from './simulator'
import { DolfinRpc } from './index'

export class DolfinRpcFactory {
  static readonly DolfinRpcTypes = {
    SUPABASE: 'supabase',
    SIMULATOR: 'simulator',
    SIMULATION: 'simulator'
  }

  static create(
    type?: (typeof DolfinRpcFactory.DolfinRpcTypes)[keyof typeof DolfinRpcFactory.DolfinRpcTypes],
    client?: any,
    config?: SimulatorDBRpcConfig
  ): DolfinRpc {
    switch (type) {
      case DolfinRpcFactory.DolfinRpcTypes.SUPABASE:
        return new DolfinSupabaseDbRpc(client)
      case DolfinRpcFactory.DolfinRpcTypes.SIMULATOR:
        return new SimulatorDBRpc(client, config!)
      default:
        return new DolfinSupabaseDbRpc(client)
    }
  }
}
